import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router/composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DevApp',
    setup: function setup(__props) {
        var show = ref(false);
        var routesMaps = ref({});
        var activeNames = ref([]);
        var router = useRouter();
        var showPopup = function showPopup() {
            activeNames.value = [];
            show.value = !show.value;
        };
        var push = function push(route) {
            show.value = false;
            router.push(route.path);
        };
        var initRoutes = function initRoutes() {
            var routes = router.getRoutes();
            var routesMapsTemp = {};
            routes.forEach(function(route) {
                var path = route.path;
                var _path_replace_split = _sliced_to_array(path.replace(/^\//, '').split('/'), 1), group = _path_replace_split[0];
                if (routesMapsTemp[group]) {
                    routesMapsTemp[group].push(route);
                } else {
                    routesMapsTemp[group] = [
                        route
                    ];
                }
            });
            routesMaps.value = routesMapsTemp;
        };
        initRoutes();
        return {
            __sfc: true,
            show: show,
            routesMaps: routesMaps,
            activeNames: activeNames,
            router: router,
            showPopup: showPopup,
            push: push,
            initRoutes: initRoutes
        };
    }
});
